(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("spritejs/dist/spritejs.min.js"));
	else if(typeof define === 'function' && define.amd)
		define(["spritejs"], factory);
	else if(typeof exports === 'object')
		exports["qcharts"] = factory(require("spritejs/dist/spritejs.min.js"));
	else
		root["qcharts"] = factory(root["spritejs"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 